import { useState, useEffect } from 'react'

export const useFetchAllManagements = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataManagements, setDataManagements ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllManagements, setLoadingFetchAllManagements ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/admin-judicial-premises/fetch-all-managements`)
            // console.log('[useFetchData][useFetchAllManagements] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllManagements(true)
        fetchData()
            .then((resp) => {
                setDataManagements(resp.rows)
                setLoadingFetchAllManagements(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllManagements(false)
            })
    }, [execute])

    return { dataManagements, loadingFetchAllManagements, executeFetch }

}

export const useFetchSpecificManagement = ({marvarApi, dispatch, onLogout, Forms}) => {

    const defaultParams = {
        idmanagement: '',
        fecthReceptionInfo: {
            flag: false,
            refFetchDataFunction: null
        },
    }

    const { FormScreen } = Forms
    const { setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificManagement, setLoadingFetchSpecificManagement ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/admin-judicial-premises/fetch-specific-management/${paramsToSearch.idmanagement}`)
            // console.log('[useFetchData][useFetchSpecificManagement] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idmanagement > 0 ){
            setLoadingFetchSpecificManagement(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idmanagement: rows[0].idmanagement || '',
                        idmanagementtypes: rows[0].idmanagementtypes || '',
                        recepcion_codigo: rows[0].recepcion_codigo || '',
                        idreception: rows[0].idreception || '',
                        gestion_fecha: rows[0].gestion_fecha || '',
                        gestion_usuario: rows[0].gestion_usuario || '',
                        gestion_descripcion: rows[0].gestion_descripcion || '',
                        info_descuento: rows[0].info_descuento || '',
                        info_descuento_aprobado: rows[0].info_descuento_aprobado || '',
                        aprobacion_check: rows[0].aprobacion_check || '',
                        aprobacion_usuario: rows[0].aprobacion_usuario || '',
                        aprobacion_fecha: rows[0].aprobacion_fecha || '',
                        aprobacion_observaciones: rows[0].aprobacion_observaciones || ''
                    }))

                    // Para extraer info de un solo contenedor
                    if(paramsToSearch.fecthReceptionInfo?.flag){
                        const { refFetchDataFunction } = paramsToSearch.fecthReceptionInfo
                        refFetchDataFunction.setParamsToSearch({
                            recepcion_codigo: rows[0].recepcion_codigo
                        })
                        refFetchDataFunction.executeFetch()
                    }
                    setLoadingFetchSpecificManagement(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificManagement(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificManagement, setParamsToSearch, executeFetch }

}

export const useFetchManagementTypes = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataManagementTypes, setDataManagementTypes ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchManagementTypes, setLoadingFetchManagementTypes ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/admin-judicial-premises/fetch-management-types`)
            // console.log('[useFetchData][useFetchManagementTypes] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchManagementTypes(true)
        fetchData()
            .then((resp) => {
                setDataManagementTypes(resp.rows)
                setLoadingFetchManagementTypes(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchManagementTypes(false)
            })
    }, [execute])

    return { dataManagementTypes, loadingFetchManagementTypes, executeFetch }

}

export const useFetchInfoVehicleReception = ({marvarApi, dispatch, onLogout, Forms}) => {

    const { FormScreen } = Forms
    const { setFormState } = FormScreen

    const [ paramsToSearch, setParamsToSearch ] = useState({
        recepcion_codigo: ''
    })
    const [ loadingFetchInfoVehicleReception, setLoadingFetchInfoVehicleReception ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (paramsToSearch.recepcion_codigo !== '') {
            try {
                const _body = {
                    idreception: parseInt(paramsToSearch.recepcion_codigo.match(/\d+/)[0], 10)
                }
                const response = await marvarApi.post(`/admin-judicial-premises/fetch-info-vehicle-reception`, _body)
                // console.log('[useFetchData][useFetchInfoVehicleReception] response.data ', response.data)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }else{
            setLoadingFetchInfoVehicleReception(true)
        }

    }

    useEffect(() => {
        if (paramsToSearch.recepcion_codigo !== '') {
            setLoadingFetchInfoVehicleReception(true)
            fetchData()
                .then((resp) => {
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        infoReception: rows
                    }))
                    setLoadingFetchInfoVehicleReception(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { loadingFetchInfoVehicleReception, executeFetch, setParamsToSearch }

}